import { View } from "@/components/ui/view";
import Svg, { G, Path, Ellipse } from 'react-native-svg';
import { useEffect, useState, useContext } from "react";
import { Modal, Platform } from "react-native";
import { GlobalState } from "@/containers/GlobalState";

const ina = "M35.3885 3C36.7539 3 37.9242 3.78899 38.7044 4.77523C39.8747 6.35321 41.2401 10.1009 38.5094 11.0872C37.144 11.6789 38.3143 13.8486 38.3143 15.2294C39.6797 14.6376 40.85 14.4404 42.2154 13.4541C44.3609 11.8761 45.9214 8.32569 46.1164 8.12844C46.5065 7.5367 47.2867 7.73395 47.6768 8.12844C48.0669 8.52294 48.0669 9.11468 47.8719 9.70642C46.3115 13.8486 45.3362 16.0183 39.8747 18.1881C39.0945 18.5826 37.9242 22.5275 38.5094 23.1193C38.8995 23.5138 41.045 22.922 42.0203 22.922C44.9461 23.3165 46.8966 25.4862 46.7016 28.445C46.7016 30.0229 46.5065 31.7982 46.1164 33.3761H41.4352C41.4352 32.3899 41.6302 31.4037 41.6302 30.4174C41.6302 29.2339 41.2401 28.8395 40.2648 28.6422C37.9242 28.2477 36.7539 28.8394 35.9737 31.0092C34.0232 36.1376 31.8776 41.0688 29.3419 46C27.7815 44.8165 26.026 44.0275 23.8805 43.633C25.2458 41.4633 26.6112 39.2936 28.1716 37.3211C31.8776 32.7844 33.438 27.4587 34.4133 21.9358C34.8034 19.9633 34.4133 17.3991 34.8034 15.0321C33.0479 16.4128 32.6578 18.5826 31.6825 20.3578C29.537 24.1055 25.2458 28.0505 22.5151 31.4037C21.9299 31.9954 21.3448 32.3899 20.5646 31.9954C19.7844 31.6009 19.9794 30.8119 20.1745 30.2202C20.1745 29.8257 20.3695 29.4312 20.5646 29.0367C21.1497 27.8532 21.3448 26.6697 20.7596 25.289C20.1745 23.711 21.3448 21.9358 20.7596 20.1606C20.5646 19.5688 21.3448 19.3716 21.9299 18.9771C25.831 16.6101 30.9023 13.2569 35.7786 12.0734C32.0726 11.2844 30.5122 9.70642 30.5122 7.1422C30.5122 5.16973 31.8776 3.59174 33.8281 3C34.6083 3 34.9984 3 35.3885 3Z"

export default function ModalWaiting({ showModal }) {

    const [phase, setPhase] = useState(0)
    const { inAColors } = useContext(GlobalState)

    useEffect(() => {
        if (Platform.OS !== 'web') {
            let syncInterval
            if (showModal) {
                syncInterval = setInterval(() => {
                    let p = 0
                    setPhase((phase) => { p = (phase + 1) % 2; return p })
                }, 1000)
            } else {
                if (syncInterval) {
                    clearInterval(syncInterval)
                    syncInterval = null
                }
            }
            return function cleanup() {
                if (syncInterval) {
                    clearInterval(syncInterval)
                    syncInterval = null
                }
            }
        }
    }, [showModal])

    const webProps = Platform.OS == 'web' ? { maxWidth: 390, width: '100%', maxHeight: 844, height: '100%', margin: 'auto', overflow: 'hidden' } : {}
    return (
        <Modal visible={showModal} statusBarTranslucent={true} transparent={true}>
            <View {...webProps} className="flex-1 bg-[#00000050]">
                <Svg height='100%' width='100%' viewBox='0 0 150 40' shapeRendering='crispEdges'>
                    <G transform={`translate(40 0)`}>
                        <Path key={phase} fill={inAColors.secondary[50]} d='M68 65.2C68 66.8 66.7 68 65.2 68H2.8C1.3 68 0 66.8 0 65.2V2.8C0 1.3 1.3 0 2.8 0H65.2C66.8 0 68 1.3 68 2.8V65.2Z' />
                        <Ellipse cx='34' cy='58' rx='21' ry='5' fill='black' opacity='0.3' />
                        <Ellipse cx='34' cy='57' rx='20' ry='5' fill='#D9D9D9' />
                        <G transform={'translate(6 ' + (10 * phase +8) + ') scale(0.8)'}>
                            <Path fill={inAColors.primary[900]} d={ina} />
                        </G>
                    </G>
                </Svg>
            </View>
        </Modal>
    );
}
